import {RouteLang} from "~~/route/enum/route-lang.enum";

export const useSchemaOrg = () => {
    const config = useRuntimeConfig().public
    const {locale, t} = useI18n();
    const route = useRoute()
    // Use runtime config or default for base URL
    const baseUrl = config.siteUrl || 'https://www.enerwin-aermec.be'
    // Organization schema
    const organizationSchema = {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: config.siteName,
        url: baseUrl,
        logo: `${baseUrl}${config.logo.horizontal}`,
        description: t('seo.title'),
        address: {
            '@type': 'PostalAddress',
            streetAddress: config.contact.address.street,
            addressLocality: config.contact.address.city,
            postalCode: config.contact.address.postcode,
            addressCountry: config.contact.address.country
        },
        contactPoint: {
            '@type': 'ContactPoint',
            telephone: config.contact.phone,
            email: config.contact.email,
            contactType: 'customer service',
            availableLanguage: Object.values(RouteLang).map(l => l.toLowerCase())
        },
        sameAs: [
            config.socials.linkedin,
            config.socials.instagram
        ]
    }
    // LocalBusiness schema
    const localBusinessSchema = {
        '@context': 'https://schema.org',
        '@type': 'LocalBusiness',
        '@id': `${baseUrl}/#localbusiness`,
        name: config.siteName,
        image: `${baseUrl}${config.logo.horizontal}`,
        telephone: config.contact.phone,
        email: config.contact.email,
        url: baseUrl,
        address: {
            '@type': 'PostalAddress',
            streetAddress: config.contact.address.street,
            addressLocality: config.contact.address.city,
            postalCode: config.contact.address.postcode,
            addressCountry: config.contact.address.country
        },
        geo: {
            '@type': 'GeoCoordinates',
            latitude: 50.717,
            longitude: 4.612
        },
        openingHoursSpecification: [
            {
                ...config.openingHoursSpecification
            }
        ],
        priceRange: '$$'
    }
    // WebSite schema with search action
    const websiteSchema = {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        '@id': `${baseUrl}/#website`,
        url: baseUrl,
        name: config.siteName,
        description: t('seo.title'),
        inLanguage: Object.values(RouteLang).map(l => l.toLowerCase()),
        publisher: {
            '@id': `${baseUrl}/#organization`
        }
    }
    // WebPage schema
    const webPageSchema = (title: string, description: string) => ({
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        '@id': `${baseUrl}${route.fullPath}#webpage`,
        url: `${baseUrl}${route.fullPath}`,
        name: title,
        description: description,
        isPartOf: {
            '@id': `${baseUrl}/#website`
        },
        inLanguage: locale.value,
        dateModified: new Date().toISOString().split('T')[0]
    })
    // BreadcrumbList schema
    const breadcrumbSchema = (items: { name: string; url: string }[]) => ({
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: items.map((item, index) => ({
            '@type': 'ListItem',
            position: index + 1,
            name: item.name,
            item: `${baseUrl}${item.url}`
        }))
    })
    const addSchemas = (schemas: any[]) => {
        useHead({
            script: schemas.map(schema => ({
                type: 'application/ld+json',
                innerHTML: JSON.stringify(schema)
            }))
        })
    }
    return {
        organizationSchema,
        localBusinessSchema,
        websiteSchema,
        webPageSchema,
        breadcrumbSchema,
        addSchemas
    }
}
